/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
var ModalService = (function () {
    function ModalService($compile, $rootScope, _) {
        var srv = this;
        srv.$compile = $compile;
        srv.$rootScope = $rootScope;
        srv._ = _;
        this.zIndex = 5000;
    }
    ModalService.prototype.create = function (childDirective) {
        var srv = this;
        var tagName = srv._.kebabCase(childDirective);
        var element = srv.$compile("<hmy-modal><" + tagName + "/></hmy-modal>")(srv.$rootScope.$new());
        var controller = element.controller('hmyModal');
        controller.zIndex = this.zIndex++;
        return controller.getReadyPromise();
    };
    return ModalService;
}());
ModalService.$inject = ['$compile', '$rootScope', 'lodash'];
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ModalService;



//////////////////
// WEBPACK FOOTER
// ./src/components/base/modal.service.ts
// module id = 3
// module chunks = 0